import React, { useEffect } from 'react';
import { LoadingSkeleton } from '@helpcenter/loading';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

export const Skeleton = ({ onUnmount }: { onUnmount?: () => void }) => {
	useEffect(() => () => onUnmount?.(), [onUnmount]);
	return (
		<Box xcss={containerStyles}>
			<LoadingSkeleton height={40} backgroundColor={token('color.skeleton.subtle', '#F4F5F7')} />
		</Box>
	);
};

const containerStyles = xcss({
	width: '100%',
});
